import { useController } from 'react-hook-form';
import AutocompleteBase, {
  AutocompleteBaseProps,
} from './autocomplete-base/autocomplete-base.component';
import { useOnAutocompleteChange } from './autocomplete-field.hooks';

export type AutocompleteFieldProps = {
  name: string;
  options: any[];
  multiple?: boolean;
  inputTextField?: any;
  valueGetter?: (option: any) => any;
  handleAdditionalLogicBeforeOnChange?: (value: any) => void;
  withSelectAllOption?: boolean;
} & Partial<AutocompleteBaseProps>;

const AutocompleteField = ({
  name,
  options = [],
  multiple = false,
  inputTextField,
  valueGetter,
  handleAdditionalLogicBeforeOnChange,
  withSelectAllOption,
  ...rest
}: AutocompleteFieldProps) => {
  const {
    field: { onChange: rhfOnChange, value, ...fieldRest },
    fieldState: { error },
  } = useController({ name });

  const onChange = useOnAutocompleteChange(
    rhfOnChange,
    multiple,
    options,
    valueGetter,
    handleAdditionalLogicBeforeOnChange,
    withSelectAllOption,
  );

  return (
    <AutocompleteBase
      value={value ?? (multiple ? [] : null)}
      options={options}
      error={error}
      onChange={onChange}
      multiple={multiple}
      inputTextField={inputTextField}
      {...fieldRest}
      {...rest}
    />
  );
};

export default AutocompleteField;
